import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, FormGroup, Label } from 'reactstrap';
import Select, { components } from "react-select";

const OccassionTable = (props) => {
    const { setValue, trigger, settingOccassions, settingSubOccassions, occassionRows, setOccassionRows } = props;

    const handleOccassionRowChange = (idx, field, value) => {
        // If occasion category changes, also reset the sub-occasion ids so the sub-select refreshes
        if (field === 'occasion_id') {
            setOccassionRows(prev => prev.map((row, i) => i === idx ? { ...row, occasion_id: value, occasion_sub_ids: [] } : row));
        } else {
            setOccassionRows(prev => prev.map((row, i) => i === idx ? { ...row, [field]: value } : row));
        }
    };

    const handleAddWashCareRow = () => {
        setOccassionRows(prev => ([...prev, { occasion_id: '', occasion_sub_ids: [] }]));
    };

    const handleRemoveOccassionRow = (idx) => {
        setOccassionRows(prev => prev.length > 0 ? prev.filter((_, i) => i !== idx) : prev);
    };

    useEffect(() => {
        setValue("occassions", [...occassionRows]);
        trigger("occassions");
    }, [occassionRows]);

    return (
        <FormGroup>
            <Label className="form-label ai-form-heading">Occasions</Label>
            <table className="table table-bordered table-sm align-middle">
                <thead>
                    <tr>
                        <th style={{ width: '40%' }}>Occasion Category</th>
                        <th style={{ width: '40%' }}>Sub-Occasions</th>
                        <th style={{ width: '20%' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {(occassionRows || []).map((row, idx) => (
                        <tr key={idx}>
                            <td>
                                <Select
                                    placeholder="Select Occasion"
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.name}
                                    options={settingOccassions}
                                    value={settingOccassions.find(opt => opt.id === row.occasion_id) || null}
                                    onChange={selected => handleOccassionRowChange(idx, 'occasion_id', selected ? selected.id : '')}
                                />
                            </td>
                            <td>
                                <Select
                                    placeholder="Select Sub-Occasion"
                                    isMulti
                                    isDisabled={!row.occasion_id} // disable until an occasion is selected
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.name}
                                    options={settingSubOccassions.filter(opt => opt.occasion_id === row.occasion_id)}
                                    value={settingSubOccassions.filter(opt => (row.occasion_sub_ids || []).includes(opt.id))}
                                    onChange={selected => handleOccassionRowChange(idx, 'occasion_sub_ids', selected ? selected.map(s => s.id) : [])}
                                />
                            </td>
                            <td className="text-center">
                                <Button 
                                    color="danger" 
                                    size="sm" 
                                    onClick={() => handleRemoveOccassionRow(idx)} 
                                    // disabled={occassionRows.length === 1}
                                ><i className="fa fa-trash" /></Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Button color="success" size="sm" className="mt-2" onClick={handleAddWashCareRow}><i className="fa fa-plus" /> Add Row</Button>
        </FormGroup>
    );
};

export default OccassionTable;
